<template>
  <div class="btgb-metaverse" id="main-wrapper">
    <canvas id="renderCanvas" ref="myCanvas"></canvas>
    <transition>
      <div class="avatar-container" v-show="currentState >= 2">
        <div class="avatar">
          <img :src="avatarImg[chosenAvatar]" alt="" />
          <p class="name">{{ usrName }}</p>
        </div>
        <div class="dialog">
          <img src="@/assets/img/role/dialog.png" />
          <p class="bubble">{{ dialog[dialogIndex] }}</p>
        </div>
      </div>
    </transition>
    <div class="right-area">
      <div style="width: 40px" v-show="liveState >= LIVE_END">
        <a
          href="https://www.facebook.com/BrandingTaiwanForward/posts/"
          target="_blank"
          ><img style="width: 100%" src="@/assets/img/fb.png"
        /></a>
      </div>
      <div class="area-bar" v-show="currentState >= 6">
        <div
          class="tag tag-1"
          v-bind:class="{ active: isArea === 0 }"
          @click="moveToArea(0)"
        >
          <span>星空舞台</span>
          <div class="circle"></div>
        </div>
        <div
          class="tag tag-2"
          v-bind:class="{ active: isArea === 1 }"
          @click="moveToArea(1)"
        >
          <span>最佳品牌</span>
          <div class="circle"></div>
        </div>
        <div
          class="tag tag-3"
          v-bind:class="{ active: isArea === 2 }"
          @click="moveToArea(2)"
        >
          <span>潛力之星</span>
          <div class="circle"></div>
        </div>
      </div>
    </div>
    <div class="coin-bar" v-show="currentState >= 6">
      <img
        class="coin"
        v-for="(item, index) in coinData"
        :key="index"
        :src="[
          hasFoundCoin[index]
            ? coinData[index].found
            : coinData[index].notFound,
        ]"
      />
    </div>
    <div class="play-btn" v-show="currentState >= 6" @click="playBGM">
      <img :src="[isPlaying ? playImg[0] : playImg[1]]" />
    </div>
    <div class="faq-btn" v-show="currentState >= 6" @click="showFAQ">
      <img :src="[isFAQ ? faqImg[0] : faqImg[1]]" />
    </div>
    <a class="gift-btn" v-show="currentState >= 6" href="https://www.facebook.com/BrandingTaiwanForward/posts/400965878441238" target="_blank">
      <img src="@/assets/img/gift_off.png" />
    </a>
    <iframe
      class="full-video"
      v-if="fullscreenToggle"
      :class="{ active: fullscreenToggle }"
      :src="YTLink[liveState]"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <img
      src="@/assets/img/x.png"
      style="
        position: absolute;
        z-index: 3000;
        width: 50px;
        top: 50px;
        right: 50px;
      "
      v-show="
        fullscreenToggle && (liveState < LIVE_PREPARE || liveState >= LIVE_END)
      "
      @click="fullscreenToggle = false"
    />
    <Popup
      v-if="popStatus"
      v-show="currentState <= 10"
      :class="{ 'small-size': currentState >= 2 }"
      :state="currentState"
      :avatar="chosenAvatar"
      @setDialogIndex="setDialogIndex"
      @setAvatar="setAvatar"
      @moveToStage="moveToStage"
      @moveTo25="moveTo25"
      @next="next"
      @start="start"
      @closeFAQ="closeFAQ"
      @closePop="closePop"
      @setName="setName"
      @clickDot="clickDot"
    />
    <Landing v-if="landing" :loaded="loaded" @enter="enter" />
  </div>
</template>

<script>
import {
  Engine,
  Scene,
  SceneLoader,
  HemisphericLight,
  Vector3,
  Light,
  ActionManager,
  ExecuteCodeAction,
  PointerEventTypes,
  MeshBuilder,
  StandardMaterial,
  Texture,
  Color3,
  Mesh,
  Sound,
  SineEase,
  Animation,
  FreeCamera,
} from "babylonjs";
import "babylonjs-loaders";
import * as GUI from "babylonjs-gui";
import Popup from "../components/Popup.vue";
import Landing from "../components/Landing.vue";
import gsap from "gsap";
import axios from "axios";
let canvas, engine, scene, camera;
let planetOrign = null;
let icons = [];
let planets = [];
let coinParents = [];
let music;
let cameraPosParam = {
  Fullscreen: {
    targetPos: {
      x: 1.5149753889694755,
      y: 2.8334975531488413,
      z: 33.31161819652159,
    },
    newPos: { x: 1.5, y: 3.2, z: 17 },
  },
  UI_stage_1: {
    targetPos: {
      x: -0.8282063959395787,
      y: 3.7445896065809707,
      z: 27.76676240930769,
    },
    newPos: { x: -0.5141819715499878, y: 2.4671499729156494, z: 10 },
  },
  UI_25_1: {
    targetPos: {
      x: -0.9129850224483927,
      y: 2.679700639427831,
      z: 8.50089818327918,
    },
    newPos: { x: -1, y: 2.6792800426483154, z: 3.9857800006866455 },
  },
  UI_new_1: {
    targetPos: {
      x: 0.3204358377909328,
      y: 1.7386147119285251,
      z: 6.640945136648446,
    },
    newPos: { x: 0.8, y: 2.6792800426483154, z: -4.097400188446045 },
  },
  UI_LF_1: {
    targetPos: {
      x: 9.037935548235573,
      y: 2.397161359520297,
      z: 12.988758518096756,
    },
    newPos: { x: -7, y: 2.0387399196624756, z: -3 },
  },
  UI_LB_1: {
    targetPos: { x: -2.628153125739, y: 3.36931448963, z: 17.77271729612403 },
    newPos: { x: -9, y: 2.2287399768829346, z: 1.6 },
  },
  UI_RF_1: {
    targetPos: {
      x: 0.4328849790554177,
      y: 0.5526325803101722,
      z: 2.7713929901633367,
    },
    newPos: { x: 9, y: 2.0387399196624756, z: 0 },
  },
  UI_RB_1: {
    targetPos: {
      x: 1.8503096123078047,
      y: 3.0900863076377503,
      z: 17.58012080236548,
    },
    newPos: { x: 8.548439979553223, y: 2.2287399768829346, z: 2.2 },
  },
};

export default {
  name: "BTGB",
  data() {
    return {
      LIVE_BEFORE: 0,
      LIVE_PREPARE: 1,
      LIVE_START: 2,
      LIVE_END: 3,
      LIVE_AFTER: 4,
      liveState: 0,
      YTLink: [
      "https://www.youtube.com/embed/yn0lRGZuQww?autoplay=1&controls=0&rel=0&modestbranding=1", // LIVE_BEFORE
      "https://www.youtube.com/embed/yn0lRGZuQww?autoplay=1&controls=0&rel=0&modestbranding=1", // LIVE_PREPARE
      "https://www.youtube.com/embed/yn0lRGZuQww?autoplay=1&controls=0&rel=0&modestbranding=1", // LIVE_START
      "https://www.youtube.com/embed/cdYPkyGskdk?autoplay=1&controls=0&rel=0&modestbranding=1", // LIVE_END
      "https://www.youtube.com/embed/kmuW99yrptU?autoplay=1&controls=0&rel=0&modestbranding=1&playlist=kmuW99yrptU&loop=1", // LIVE_AFTER
      ],
      landing: true,
      loaded: false,
      popStatus: true,
      currentState: 0,
      chosenAvatar: 0,
      avatarImg: [
        `${require(`@/assets/img/role/p1only.png`)}`,
        `${require(`@/assets/img/role/p2only.png`)}`,
        `${require(`@/assets/img/role/p3only.png`)}`,
        `${require(`@/assets/img/role/p4only.png`)}`,
      ],
      usrName: "",
      dialogIndex: 0,
      dialog: [
        "很開心可以來虛擬宇宙和大家一起交流！", //0
        "虛擬宇宙太酷了！", //1
        "一起來看看有哪些優秀的品牌吧！", //2
        "哇！不曉得這些符號隱藏在哪呢？", //3
        "小禮物看起來都好棒！", //4
        "看來點擊這邊還可以看更多資訊？", //5
        "跟著我一起四處逛逛吧！", //6
        "哇！這邊都是優秀的潛力之星！", //7
        "「台灣最佳國際品牌」都在這呢！", //8
        "活動要開始了，快來舞台前吧", //9
        "即將要揭曉了，真期待！", //10
        "不曉得我們品牌今年表現如何呢？", //11
        "我還想回到虛擬宇宙中再逛逛呢", //12
        "點下方臉書看更多資訊", //13
      ],
      isArea: 2,
      hasFoundCoin: [false, false, false, false, false],
      coinData: [
        {
          data: "B",
          notFound: `${require(`@/assets/img/coin/B.png`)}`,
          found: `${require(`@/assets/img/coin/B-active.png`)}`,
        },
        {
          data: "R",
          notFound: `${require(`@/assets/img/coin/R.png`)}`,
          found: `${require(`@/assets/img/coin/R-active.png`)}`,
        },
        {
          data: "E",
          notFound: `${require(`@/assets/img/coin/E.png`)}`,
          found: `${require(`@/assets/img/coin/E-active.png`)}`,
        },
        {
          data: "A",
          notFound: `${require(`@/assets/img/coin/A.png`)}`,
          found: `${require(`@/assets/img/coin/A-active.png`)}`,
        },
        {
          data: "K",
          notFound: `${require(`@/assets/img/coin/K.png`)}`,
          found: `${require(`@/assets/img/coin/K-active.png`)}`,
        },
      ],
      playImg: [
        `${require(`@/assets/img/play-on.png`)}`,
        `${require(`@/assets/img/play-off.png`)}`,
      ],
      faqImg: [
        `${require(`@/assets/img/FAQ-on.png`)}`,
        `${require(`@/assets/img/FAQ-off.png`)}`,
      ],
      isPlaying: false,
      isFAQ: false,
      fullscreenToggle: false,

      pk: null,
    };
  },
  components: {
    Popup,
    Landing,
  },
  created() {
    axios.get(`https://btgb-2021-web-app.azurewebsites.net/current_timestamp`).then((res) => {
      const currentTime = Number(`${res.data.data}000`);
      const targetTime = new Date('2021/12/02 9:30').getTime();
      // if(targetTime - currentTime > 0){
      if(targetTime - currentTime > 0){
        this.$router.push('/')
      }
    });
  },
  mounted() {
    let loginTime = new Date();

    if (localStorage.getItem("timestamp") !== null) {
      let previousLoginTime = parseInt(localStorage.getItem("timestamp"));

      if (loginTime.getTime() - previousLoginTime < 1000 * 60 * 60 * 24) {
        if (localStorage.getItem("userid") !== null) {
          this.getUser();
          this.usrName = localStorage.getItem("usrName");
          this.currentState = 1;
          if (localStorage.getItem("avatar") !== null) {
            this.chosenAvatar = parseInt(localStorage.getItem("avatar"));
            this.currentState = 2;
          }
        }
      } else {
        localStorage.removeItem("timestamp");
      }
    } else {
      localStorage.setItem("timestamp", loginTime.getTime());
    }

    this.setBabylon();
  },
  methods: {
    getYoutube() {
      axios
        .get(`https://btgb-2021-web-app.azurewebsites.net/activity`)
        .then((res) => {
          console.log(res);
        });
    },
    getUser() {
      let id = {
        uuid: localStorage.getItem("userid"),
      };
      axios
        .get(`https://btgb-2021-web-app.azurewebsites.net/user`, {
          params: id,
        })
        .then((res) => {
          console.log(res);
        });
    },
    setCollection(letter) {
      let param = {
        uuid: this.$getRsaCode(localStorage.getItem("userid")),
        letter: this.$getRsaCode('["' + letter + '"]'),
      };
      console.log(param);
      axios({
        method: "post",
        url: `https://btgb-2021-web-app.azurewebsites.net/user/collection`,
        data: param,
      }).then((res) => {
        console.log(res);
      });
    },
    setBabylon() {
      const vm = this;
      canvas = this.$refs.myCanvas;
      window.mesh = Mesh;
      if (!canvas) return;

      setEngine();
      setScene();
      setLights();
      setExhibition();
      setCamera();
      setBGMSound();
      // setYoutube();

      function setEngine() {
        engine = new Engine(
          canvas,
          true,
          {
            // preserveDrawingBuffer: true,
            stencil: true,
            // doNotHandleContextLost: true,
            disableWebGL2Support: false,
          },
          true
        );
        Engine.audioEngine.setGlobalVolume(0.6);

        // 監聽瀏覽器改變大小的事件，通過調用engine.resize()來自適應窗口大小
        window.addEventListener("resize", function () {
          engine.resize();
        });
      }

      function setScene() {
        // 創建一個場景scene
        scene = new Scene(engine);
        scene.executeWhenReady(function () {
          vm.loaded = true;

          // 最後一步調用engine的runRenderLoop方案，執行scene.render()，讓我們的3d場景渲染起來
          engine?.runRenderLoop(function () {
            if (!scene || !canvas) return;
            scene.render();
          });
        });
        window.scene = scene;

        scene.registerBeforeRender(() => {
          planets.forEach((e) => {
            if (e.logoMesh.rotating) {
              e.logoMesh.rotation.y += 0.02;
            }
          });
        });

        // scene.onBeforeRenderObservable.add(() => {
        // });

        scene.onPointerObservable.add((p) => {
          if (p.type === PointerEventTypes.POINTERTAP) {
            console.log(p.pickInfo?.pickedMesh?.name);
            console.log(p.pickInfo?.pickedMesh?.position);
          }
        });
      }

      function setPlanetsAnimation() {
        planets.forEach((e) => {
          let toPos = e.position.y;
          let duration = 3.5;
          if (Math.floor(Math.random() * 4) % 4 == 0) {
            toPos += 0.4;
          } else if (Math.floor(Math.random() * 4) % 4 == 1) {
            toPos += 0.8;
          } else if (Math.floor(Math.random() * 4) % 4 == 2) {
            toPos -= 0.8;
          } else {
            toPos -= 0.4;
          }

          gsap.to(e.position, {
            y: toPos,
            duration: duration,
            repeat: -1,
            yoyo: true,
          });
        });
      }

      function setPlanetsInteraction() {
        planets.forEach((e) => {
          const planetsActionManager = new ActionManager(scene);

          e.logoMesh = scene.getMeshByName(e.name.split("-", 1).toString());
          e.logoMesh.rotationQuaternion = null;
          e.logoMesh.visibility = 0;
          e.logoMesh.rotating = false;

          planetsActionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPointerOverTrigger, function (
              event
            ) {
              e.logoMesh.visibility = 1;
              e.logoMesh.rotating = true;
            })
          );
          planetsActionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPointerOutTrigger, function (
              event
            ) {
              e.logoMesh.visibility = 0;
              e.logoMesh.rotating = false;
            })
          );
          planetsActionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPickDownTrigger, function (
              event
            ) {
              planets.forEach((e) => {
                e.logoMesh.visibility = 0;
                e.logoMesh.rotating = false;
              });
              e.logoMesh.visibility = 1;
              e.logoMesh.rotating = true;
              checkCollected(e);
            })
          );

          e.actionManager = planetsActionManager;

          const logosActionManager = new ActionManager(scene);

          logosActionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPickDownTrigger, function (
              event
            ) {
              planets.forEach((e) => {
                e.logoMesh.visibility = 0;
                e.logoMesh.rotating = false;
              });
              e.logoMesh.visibility = 1;
              e.logoMesh.rotating = true;
              checkCollected(e);
            })
          );

          logosActionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPointerOverTrigger, function (
              event
            ) {
              e.logoMesh.visibility = 1;
              e.logoMesh.rotating = true;
            })
          );

          logosActionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPointerOutTrigger, function (
              event
            ) {
              e.logoMesh.visibility = 0;
              e.logoMesh.rotating = false;
            })
          );

          e.logoMesh.actionManager = logosActionManager;
        });
      }

      function checkCollected(e) {
        if (e.hasCoin) {
          let coinIndex = coinParents.indexOf(e);

          if (e.coin.isVisible) {
            vm.$set(vm.hasFoundCoin, coinIndex, true);
            let letter = vm.coinData[coinIndex].data;
            vm.setCollection(letter);
            e.coin.isVisible = false;
            e.coin.spark.isVisible = false;

            if (vm.hasFoundCoin.every((x) => x === true)) {
              vm.currentState = 7;
              vm.popStatus = true;
            }
          }

          if (vm.hasFoundCoin[coinIndex]) {
            e.coin.isVisible = false;
            e.coin.spark.isVisible = false;
          } else {
            e.coin.isVisible = true;
            e.coin.spark.isVisible = true;
          }
        }
      }

      function setCameraPosition() {
        const flyPos = scene.getMeshByName("T_fly").position;
        const tempFlyPos = new Vector3(flyPos.x, flyPos.y, flyPos.z * -1);

        const UIName = [
          "UI_25",
          "UI_new",
          "UI_stage",
          "UI_LF",
          "UI_LB",
          "UI_RF",
          "UI_RB",
        ];
        const hideName = [
          "Coin_B",
          "Coin_R",
          "Coin_E",
          "Coin_A",
          "Coin_K",
          "T_start",
          "T_fly",
          "UI_25",
          "UI_new",
          "UI_stage",
          "UI_LB",
          "UI_LF",
          "UI_RB",
          "UI_RF",
        ];
        const advancedTexture =
          GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
        const ease = new SineEase();

        camera.position = tempFlyPos;

        camera.ellipsoid.set(0.1, 0.1, 0.1);
        camera.minZ = 0;
        camera.speed = 0;
        camera.fov = 0.7;

        scene.meshes.forEach((e) => {
          for (let i = 0; i < UIName.length; i++) {
            if (e.name === UIName[i]) {
              let icon = MeshBuilder.CreatePlane("", {
                width: 1,
                height: 1,
              });

              let UIMesh = e;

              icon.position.set(
                UIMesh.position.x + 0.2,
                UIMesh.position.y + 0.2,
                UIMesh.position.z * -1
              );

              icon.rotation.x = 1;
              icon.scaling.x = 0.6;
              icon.scaling.y = 0.6;
              icon.scaling.z = 0.6;

              icon.name = UIName[i] + "_1";

              let mat = new StandardMaterial("", scene);
              let texture = new Texture("/arrow.png", scene);
              let action = new ActionManager(scene);
              texture.hasAlpha = true;
              mat.diffuseTexture = texture;
              mat.backFaceCulling = true;
              mat.opacityTexture = texture;
              // mat.emissiveTexture = texture;
              mat.emissiveColor = new Color3.White();
              mat.disableLighting = true;
              icon.material = mat;
              icon.billboardMode = Mesh.BILLBOARDMODE_ALL;
              icon.actionManager = action;

              icon.visibility = 1;
              icons.push(icon);

              let target = cameraPosParam[icon.name].targetPos;
              let targetPos = new Vector3(target.x, target.y, target.z);
              let pos = cameraPosParam[icon.name].newPos;
              let newPos = new Vector3(pos.x, pos.y, pos.z);

              // GUI settings
              let image = new GUI.Image("iconImage", "/arrow.png");
              image.width = "55px";
              image.height = "55px";
              image.alpha = 0;
              advancedTexture.addControl(image);
              image.linkWithMesh(icon);

              action.registerAction(
                new ExecuteCodeAction(
                  ActionManager.OnPickDownTrigger,
                  function (event) {
                    gsap.to(image, {
                      alpha: 0,
                      width: "70px",
                      height: "70px",
                      duration: 0.6,
                      onComplete: () => {},
                    });

                    if (e.name === "UI_stage") {
                      vm.isArea = 0; // vm.$set(vm.isArea, 0);
                      if (vm.liveState == vm.LIVE_BEFORE) {
                        vm.dialogIndex = 10 + Math.floor(Math.random() * 2);
                      } else if (vm.liveState == vm.LIVE_PREPARE || vm.liveState == vm.LIVE_START) {
                        vm.dialogIndex = 9;
                      } else if (vm.liveState == vm.LIVE_END) {
                        vm.dialogIndex = 12;
                      } else {
                        vm.dialogIndex = 13;
                      }
                    } else if (
                      e.name === "UI_LB" ||
                      e.name === "UI_RB" ||
                      e.name === "UI_25"
                    ) {
                      if (vm.liveState < vm.LIVE_PREPARE || vm.liveState >= vm.LIVE_END) {
                        vm.isArea = 1; // vm.$set(vm.isArea, 1);
                        vm.dialogIndex = 8;
                      }
                    } else {
                      if (vm.liveState < vm.LIVE_PREPARE || vm.liveState >= vm.LIVE_END) {
                        vm.isArea = 2; // vm.$set(vm.isArea, 2);
                        vm.dialogIndex = 7;
                      }
                    }

                    let speed = 2;
                    if (
                      e.name === "UI_stage" ||
                      e.name === "UI_new" ||
                      e.name === "UI_25"
                    ) {
                      speed = 1;
                    }
                    if (targetPos && (vm.liveState < vm.LIVE_PREPARE || vm.liveState >= vm.LIVE_END)) {
                      Animation.CreateAndStartAnimation(
                        "targetChangedAnimation",
                        camera,
                        "target",
                        1,
                        speed,
                        camera.target,
                        targetPos,
                        0,
                        ease,
                        () => {}
                      );

                      Animation.CreateAndStartAnimation(
                        "targetChangedAnimation",
                        camera,
                        "position",
                        1,
                        speed,
                        camera.position,
                        newPos,
                        0,
                        ease,
                        () => {
                          image.alpha = 0;
                          image.width = "55px";
                          image.height = "55px";
                        }
                      );
                    }
                  }
                )
              );
            }
          }

          for (let i = 0; i < hideName.length; i++) {
            if (e.name === hideName[i]) e.isVisible = false;
            if (e.name === "HideScreen") e.visibility = 0;
          }
        });
      }
      function setLights() {
        let ambLight = new HemisphericLight(
          "HemiLight",
          new Vector3(1.5, 1, 1),
          scene
        );
        ambLight.lightmapMode = Light.LIGHTMAP_SHADOWSONLY;
        ambLight.Intensity = 5.2;
      }
      function setBGMSound() {
        music = new Sound("./", "sound/Short.mp3", scene, null, {
          loop: true,
          autoplay: false,
        });
      }
      function setCamera() {
        camera = new FreeCamera("FreeCamera", new Vector3.Zero(), scene);
        camera.attachControl(canvas, true);
        camera.lowerRadiusLimit = 0;
        camera.upperRadiusLimit = 0;
        camera.panningSensibility = 99999999999;
        camera.angularSensibility = 4000;
        camera.invertRotation = screen.width < 900;
        window.camera = camera;
      }

      function setOthersActionManager() {
        const actionManager = new ActionManager(scene);
        actionManager.registerAction(
          new ExecuteCodeAction(ActionManager.OnPickTrigger, function (event) {
            if (vm.liveState == vm.LIVE_BEFORE) {
              vm.dialogIndex = 10 + Math.floor(Math.random() * 2);
            } else if (vm.liveState == vm.LIVE_PREPARE || vm.liveState == vm.LIVE_START) {
              vm.dialogIndex = 9;
            } else if (vm.liveState == vm.LIVE_END) {
              vm.dialogIndex = 12;
            } else {
              vm.dialogIndex = 13;
            }

            let target = null;
            let pos = null;
            let showVideo = false;

            if (vm.isArea == 0) {
              target = cameraPosParam["Fullscreen"].targetPos;
              pos = cameraPosParam["Fullscreen"].newPos;
              showVideo = true;
            } else {
              target = cameraPosParam["UI_stage_1"].targetPos;
              pos = cameraPosParam["UI_stage_1"].newPos;
            }

            let targetPos = new Vector3(target.x, target.y, target.z);
            let newPos = new Vector3(pos.x, pos.y, pos.z);

            if (targetPos != null && newPos != null) {
              Animation.CreateAndStartAnimation(
                "targetChangedAnimation",
                camera,
                "position",
                0.5,
                1,
                camera.position.clone(),
                newPos.clone(),
                0,
                new SineEase(),
                () => {}
              );
              Animation.CreateAndStartAnimation(
                "targetChangedAnimation",
                camera,
                "target",
                1,
                1,
                camera.target,
                targetPos,
                0,
                new SineEase(),
                () => {
                  setTimeout(function () {
                    camera.setTarget(targetPos);

                    if (showVideo) {
                      vm.fullscreenToggle = true;
                      vm.stopMusic();
                    } else {
                      vm.isArea = 0;
                    }
                  }, 1500);
                }
              );
            }
          })
        );
        scene.getMeshByName("HideScreen").actionManager = actionManager;
      }

      function setExhibition() {
        SceneLoader.AppendAsync(
          "./",
          "PlanetScene-Y.glb",
          scene,
          function () {}
        )
          .then(function (scene) {
            planetOrign = scene.getTransformNodeByName("Ground");
            planetOrign.parent.rotationQuaternion = null; //this will help for the rotation anim later
            scene.getMeshByName("skyball").material.disableLighting = true;

            scene.meshes.forEach((e) => {
              if (e.name.includes("planet")) {
                planets.push(e);
              }
            });
            setCameraPosition();
            setPlanetsAnimation();
            setPlanetsInteraction();
            setOthersActionManager();
          })
          .catch(function (err) {
            console.log("Something went wrong with ", err);
          });
      }
    },
    showFAQ() {
      if (this.isFAQ) {
        this.popStatus = false;
      } else {
        this.currentState = 10;
        this.popStatus = true;
      }
      this.isFAQ = !this.isFAQ;
      console.log(this.isFAQ);
    },
    playBGM() {
      if (this.isPlaying) {
        music.stop();
        this.isPlaying = false;
      } else {
        music.play();
        this.isPlaying = true;
      }
      // this.isPlaying = !this.isPlaying;
    },
    stopMusic() {
      this.isPlaying = false;
      music.stop();
    },
    clickDot(index) {
      this.currentState = index;
    },
    // resize() {
    //   if (window.matchMedia("(orientation: portrait)").matches) {
    //     let vh = window.innerWidth * 0.01;
    //     document.documentElement.style.setProperty("--vh", `${vh}px`);
    //   } else {
    //     let vh = window.innerHeight * 0.01;
    //     document.documentElement.style.setProperty("--vh", `${vh}px`);
    //   }
    // },
    setAvatar(index) {
      this.chosenAvatar = index;
    },
    setDialogIndex(index) {
      this.dialogIndex = index;
    },
    moveToArea(index) {
      if (this.liveState == this.LIVE_PREPARE || this.liveState == this.LIVE_START) {
        index = 0;
      }
      this.isArea = index;
      let target = cameraPosParam["UI_stage_1"].targetPos;
      let targetPos = new Vector3(target.x, target.y, target.z);
      let pos = null;
      let newPos = null;

      if (index == 0) {
        pos = cameraPosParam["UI_stage_1"].newPos;
        if (this.liveState == this.LIVE_BEFORE) {
          this.dialogIndex = 10 + Math.floor(Math.random() * 2);
        } else if (this.liveState == this.LIVE_PREPARE || this.liveState == this.LIVE_START) {
          this.dialogIndex = 9;
        } else if (this.liveState == this.LIVE_END) {
          this.dialogIndex = 12;
        } else {
          this.dialogIndex = 13;
        }
      } else if (index == 1) {
        pos = cameraPosParam["UI_25_1"].newPos;
        this.dialogIndex = 8;
      } else {
        pos = cameraPosParam["UI_new_1"].newPos;
        this.dialogIndex = 7;
      }

      newPos = new Vector3(pos.x, pos.y, pos.z);

      if (
        this.liveState != this.LIVE_PREPARE &&
        this.liveState != this.LIVE_START &&
        targetPos != null &&
        newPos != null
      ) {
        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "position",
          0.5,
          1,
          camera.position.clone(),
          newPos.clone(),
          0,
          new SineEase(),
          () => {}
        );

        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "target",
          1,
          1,
          camera.target,
          targetPos,
          0,
          new SineEase(),
          () => {}
        );
      }
    },
    enter() {
      this.landing = false;
      BABYLON.Engine.audioEngine.unlock();
    },
    next() {
      this.currentState++;
    },
    moveToFullScreen() {
      const vm = this;
      this.isArea = 0;
      let target = cameraPosParam["Fullscreen"].targetPos;
      let pos = cameraPosParam["Fullscreen"].newPos;
      let targetPos = new Vector3(target.x, target.y, target.z);
      let newPos = new Vector3(pos.x, pos.y, pos.z);

      if (targetPos != null && newPos != null) {
        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "position",
          0.5,
          1,
          camera.position.clone(),
          newPos.clone(),
          0,
          new SineEase(),
          () => {}
        );
        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "target",
          1,
          1,
          camera.target,
          targetPos,
          0,
          new SineEase(),
          () => {
            setTimeout(function () {
              camera.setTarget(targetPos);
              vm.fullscreenToggle = true;
              vm.stopMusic();
            }, 1500);
          }
        );
      }
    },
    moveToStage() {
      let vm = this;
      this.popStatus = false;
      this.isArea = 0;
      let target = cameraPosParam["UI_stage_1"].targetPos;
      let pos = cameraPosParam["UI_stage_1"].newPos;
      let targetPos = new Vector3(target.x, target.y, target.z);
      let newPos = new Vector3(pos.x, pos.y, pos.z);
      if (targetPos != null && newPos != null) {
        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "position",
          0.5,
          1,
          camera.position.clone(),
          newPos.clone(),
          0,
          new SineEase(),
          () => {}
        );
        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "target",
          1,
          1,
          camera.target,
          targetPos,
          0,
          new SineEase(),
          () => {
            vm.moveToFullScreen()
          }
        );
      }
    },
    moveTo25() {
      this.popStatus = false;
      this.isArea = 1;
      let target = cameraPosParam["UI_stage_1"].targetPos;
      let pos = cameraPosParam["UI_25_1"].newPos;
      let targetPos = new Vector3(target.x, target.y, target.z);
      let newPos = new Vector3(pos.x, pos.y, pos.z);

      if (targetPos != null && newPos != null) {
        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "position",
          0.5,
          1,
          camera.position.clone(),
          newPos.clone(),
          0,
          new SineEase(),
          () => {}
        );
        Animation.CreateAndStartAnimation(
          "targetChangedAnimation",
          camera,
          "target",
          1,
          1,
          camera.target,
          targetPos,
          0,
          new SineEase(),
          () => {}
        );
      }
    },
    closeFAQ() {
      this.popStatus = false;
      this.isFAQ = false;
    },
    closePop() {
      this.popStatus = false;
    },
    setName(name) {
      this.usrName = name;
    },
    start() {
      this.closePop();

      const startPos = scene.getMeshByName("T_start").position;
      const tempStartPos = new Vector3(startPos.x, startPos.y, startPos.z * -1);
      setCoinsPosition();
      // setBGMSound();

      Animation.CreateAndStartAnimation(
        "targetChangedAnimation",
        camera,
        "position",
        0.5,
        1,
        camera.position.clone(),
        tempStartPos.clone(),
        0,
        new SineEase(),
        () => {}
      );


      function setCoinsPosition() {
        const coinsName = ["Coin_B", "Coin_R", "Coin_E", "Coin_A", "Coin_K"];

        let LF = scene.getTransformNodeByName("15").getChildren();
        let LB = scene.getTransformNodeByName("25").getChildren();
        let RF = scene.getTransformNodeByName("15.2").getChildren();
        let RB = scene.getTransformNodeByName("25.2").getChildren();
        let RB_1 = RB.splice(0, 6);
        let RB_2 = RB;

        let planetsArray = [LF, LB, RF, RB_1, RB_2];

        // let tempAllPlanets = [];

        // scene.meshes.forEach((e) => {
        //   if (e.name.includes("planet")) {
        //     tempAllPlanets.push(e);
        //     e.hasCoin = false;
        //     e.coin = null;
        //   }
        // });

        for (let i = 0; i < coinsName.length; i++) {
          // let index = Math.floor(Math.random() * tempAllPlanets.length);
          // let hasCoinPlanet = tempAllPlanets[index];

          // let index = Math.floor(i * 4.5);
          let arr = planetsArray[i];
          let index = Math.floor(Math.random() * arr.length);

          // let hasCoinPlanet = tempAllPlanets[index];
          let hasCoinPlanet = arr[index];
          coinParents.push(hasCoinPlanet);
          // tempAllPlanets.splice(index, 1);

          let coin = scene.getMeshByName(coinsName[i]);

          coin.parent = hasCoinPlanet;
          coin.setParent(hasCoinPlanet);
          hasCoinPlanet.addChild(coin);

          coin.position = new Vector3(0, -0.48, 0);
          coin.scaling.y *= -1;
          coin.billboardMode = Mesh.BILLBOARDMODE_Y;

          hasCoinPlanet.hasCoin = true;
          hasCoinPlanet.coin = coin;
          coin.planet = hasCoinPlanet;

          let spark = MeshBuilder.CreatePlane(
            "",
            {
              width: 0.5,
              height: 0.5,
            },
            scene
          );

          spark.parent = coin;
          spark.setParent(coin);
          coin.addChild(spark);

          spark.position = new Vector3(0, 0, 0.02);

          let mat = new StandardMaterial("", scene);
          let texture = new BABYLON.VideoTexture("./", "Spark.webm", scene);
          texture.hasAlpha = true;
          // mat.diffuseTexture = texture;
          texture.getAlphaFromRGB = true;
          mat.opacityTexture = texture;
          mat.roughness = 1;
          mat.emissiveColor = new Color3.Yellow();
          // mat.emissiveColor = new Color3.FromHexString();
          mat.disableLighting = true;
          spark.material = mat;
          spark.billboardMode = Mesh.BILLBOARDMODE_ALL;
          spark.isVisible = false;
          texture.video.play();
          coin.spark = spark;
        }
      }
      this.setLiveTime();
    },
    setLiveTime() {
      // 當前時間
      const vm = this;
      var time = new Date();
      var nowTime = new Date(
        time.getUTCFullYear(),
        time.getUTCMonth(),
        time.getUTCDate(),
        time.getUTCHours(),
        time.getUTCMinutes(),
        time.getUTCSeconds()
      );
      console.log("nowTime" + nowTime);

// 設置預備直播開始時間 : 2021/12/1 17:59:0
      var ptime = new Date();
      ptime.setFullYear(2021);
      ptime.setMonth(11); //   獲取當前 月份 (從 '0' 開始算)
      ptime.setUTCDate(1); //   獲取當前 日
      ptime.setUTCHours(17); //   獲取當前 時
      ptime.setUTCMinutes(59); //   獲取當前 分
      ptime.setSeconds(0);
      var prepareTime = ptime.getTime();
      console.log("prepareTime" + ptime);

 // 設置直播開始時間 : 2021/12/1 18:0:0
      var stime = new Date();
      stime.setFullYear(2021);
      stime.setMonth(11); //   獲取當前 月份 (從 '0' 開始算)
      stime.setUTCDate(1); //   獲取當前 日
      stime.setUTCHours(18); //   獲取當前 時
      stime.setUTCMinutes(0); //   獲取當前 分
      stime.setSeconds(0);
      var startTime = stime.getTime();
      console.log("startTime" + stime);

// 設置直播結束時間 : 2021/12/1 19:0:0
      var etime = new Date();
      etime.setFullYear(2021);
      etime.setMonth(11); //   獲取當前 月份 (從 '0' 開始算)
      etime.setUTCDate(1); //   獲取當前 日
      etime.setUTCHours(19); //   獲取當前 時
      etime.setUTCMinutes(0); //   獲取當前 分
      etime.setSeconds(0);
      var endTime = etime.getTime();
      console.log("endTime" + etime);

// 設置直播三小時後的時間 : 2021/12/1 22:0:0
      var atime = new Date();
      atime.setFullYear(2021);
      atime.setMonth(11); //   獲取當前 月份 (從 '0' 開始算)
      atime.setUTCDate(1); //   獲取當前 日
      atime.setUTCHours(22); //   獲取當前 時
      atime.setUTCMinutes(0); //   獲取當前 分
      atime.setSeconds(0);
      var afterTime = atime.getTime();
      console.log("afterTime" + atime);

      if (afterTime < nowTime) {
        console.log("已是直播三小時後");
        vm.liveStateChange(vm.LIVE_AFTER);
      } else {
        var afterOffsetTime = afterTime - nowTime;
        setTimeout(function () {
          console.log("到了直播三小時後");
          vm.liveStateChange(vm.LIVE_AFTER);
        }, afterOffsetTime);

        if (endTime < nowTime) {
          console.log("已是直播後三小時內");
          vm.liveStateChange(vm.LIVE_END);
        } else {
          var endOffsetTime = endTime - nowTime;
          setTimeout(function () {
            console.log("直播結束");
            vm.liveStateChange(vm.LIVE_END);
          }, endOffsetTime);

          if (startTime < nowTime) {
            console.log("直播中");
            vm.liveStateChange(vm.LIVE_START);
          } else {
            var startOffsetTime = startTime - nowTime;
            setTimeout(function () {
              console.log("直播開始");
              vm.liveStateChange(vm.LIVE_START);
            }, startOffsetTime);

            if (prepareTime < nowTime) {
              console.log("已進入直播預備");
              vm.liveStateChange(vm.LIVE_PREPARE);
            } else {
              var prepareOffsetTime = prepareTime - nowTime;
              setTimeout(function () {
                console.log("直播預備");
                vm.liveStateChange(vm.LIVE_PREPARE);
              }, prepareOffsetTime);

              console.log("直播開始前");
              vm.liveStateChange(vm.LIVE_BEFORE);
            }
          }
        }
      }
    },
    liveStateChange(state) {
      this.liveState = state;
      switch (state) {
        case this.LIVE_BEFORE:
          break;
        case this.LIVE_PREPARE:
          this.dialogIndex = 9;
          this.currentState = 8;
          this.popStatus = true;
          break;
        case this.LIVE_START:
          this.popStatus = false;
          if (!this.fullscreenToggle) {
            this.moveToFullScreen();
          }
          break;
        case this.LIVE_END:
          this.fullscreenToggle = false;
          this.dialogIndex = 12;
          this.currentState = 9;
          this.popStatus = false;
          break;
        case this.LIVE_AFTER:
          break;
        default:
          console.log("liveStateChange something wrong!");
      }
    },
  },
  destroyed() {
    if (engine) {
      engine.stopRenderLoop();
      engine.dispose();
    }
  },
};
</script>
<style lang='scss' scoped>
body,
html {
  width: 100vw;
  height: 100vh;
}
.btgb-metaverse {
  position: relative;
  width: 100%;
  height: 100%;
}
#renderCanvas {
  width: 100%;
  height: 100%;
  outline: none;
  touch-action: none;
}
#loadingScreen {
  position: absolute;
  width: 100%;
  height: 100%;
  color: white;
  font-size: 50px;
  text-align: center;
  background-color: #bb464bcc;
  z-index: 9999;
}
.avatar-container {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  position: absolute;
  top: 15px;
  right: -10px;

  .avatar {
    img {
      width: 20%;
      min-width: 100px;
      max-width: 120px;
    }
    p.name {
      font-size: 17px;
      color: white;
      text-align: center;
      margin: 0;
      padding-left: 1px;
      letter-spacing: 0.2em;
      width: 100px;
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
    }
  }
  .dialog {
    position: relative;
    width: 134px;
    background: white;
    border-radius: 12px;
    padding: 0px 10px;
    margin-top: 15px;
    margin-right: 8px;
    img {
      position: absolute;
      right: -14px;
      bottom: 14px;
    }
    p.bubble {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 13px;
      line-height: 29px;
      letter-spacing: 0.02em;
      color: rgba(16, 16, 16, 0.9);
      margin: 10px 0px;
    }
  }
}
.play-btn,
.faq-btn,
.gift-btn {
  position: absolute;
  top: 30px;
  left: 25px;
  width: 50px;
  img {
    width: 100%;
    cursor: pointer;
  }
}
.faq-btn {
  top: 80px;
}
.gift-btn {
  top: 130px;
}
.right-area {
  position: absolute;
  right: 25px;
  top: 140px;
  display: flex;
  flex-direction: column;
  height: calc(100% + -200px);
  max-height: 550px;
  justify-content: space-evenly;
  align-items: flex-end;

  .area-bar {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    width: 7px;
    height: 60%;
    border-radius: 8.5px;
    background: linear-gradient(
      90.43deg,
      rgba(255, 255, 255, 0.8) 35.56%,
      rgba(128, 128, 127, 0.8) 79.18%
    );
    z-index: 555;
    .tag {
      display: flex;
      transform: translateX(4px);
      width: 110px;
      cursor: pointer;
      justify-content: flex-end;
      padding: 6px 0px;
      span {
        font-size: 16px;
        color: #fff;
        margin-right: 10px;
      }
      .circle {
        width: 16px;
        height: 16px;
        background: #fff;
        border-radius: 50%;
      }
      &.active {
        background-color: #000;
        border-radius: 14.5px;
        padding: 5px 9px 4px 9px;
        width: fit-content;
        transform: translateX(14px);
        white-space: nowrap;
        .circle {
          background-color: #8500bd;
        }
      }
    }
  }
}

.coin-bar {
  pointer-events: none;
  position: absolute;
  bottom: 8%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: 40vw;
  justify-content: space-between;
  align-items: center;
  img {
    max-width: 66px;
    width: 11%;
    min-width: 35px;
  }
}

.full-video {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 666;
  width: 100%;
  height: 100%;
  display: none;
  transition: 0.3s ease-in-out all;
  pointer-events: none;
  &.active {
    display: block;
    pointer-events: all;
  }
}
//
//
.v-enter-active,
.v-leave-active {
  transition: opacity 1s;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.v-enter-to,
.v-leave-from {
  opacity: 1;
}
</style>
